import { ButtonStateType } from 'annotation-tools/utils';
import { AppMode } from '../../rect-tool-with-crop/types/enum/app-mode';

type ReducerState = { appMode: AppMode; buttonState: ButtonStateType };
type ReducerAction = AppMode | 'infer-click' | 'inference-result';

export const inferButtonStateReducer = (
  state: ReducerState,
  action: ReducerAction
): ReducerState => {
  switch (action) {
    case 'crop-image':
      return { appMode: 'crop-image', buttonState: 'disabled' };
    case 'rectbox':
      return { appMode: 'rectbox', buttonState: 'show' };
    case 'infer-click':
      return { appMode: state.appMode, buttonState: 'disabled' };
    case 'inference-result':
      return {
        appMode: state.appMode,
        buttonState: state.appMode === 'rectbox' ? 'show' : 'disabled'
      };
  }
};
